/**
 * Created by jahidul.hasan on 12/23/2020.
 */
import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {takeUntil} from 'rxjs/operators';
import {GraphqlContentScope} from "@shared/models/graphql-content-scope.model";
import {TaskManagerService} from "./task-manager.service";
import {TaskMenuDetails} from "../models/task-manager.model";

@Injectable({
  providedIn: 'root',
})

export class ActivityTrackerHandler implements IPlatformToolHandler {
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();
  magicLinkModel: MagicLinkModel;
  private selectedTabModel: TabModel;
  ngUnsubscribe = new Subject<void>();
  invalidateSubject: InvalidateSubject;

  constructor(private commandService: CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private taskManagerService: TaskManagerService
  ) {
  }

  executeCommand(command: PlatformCommand) {
    console.log('[activity-tracker-platform-command] onPlatformTool Handler Command', command);
    switch (command.name) {
      default:
        this.executeCommandToApi(command);
        break;
    }
  }

  private executeCommandToApi(command: PlatformCommand, action: string = null) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          this.invalidatePlatformLink(action, commandResponse.fieldValues['PlatformLinkModel']);
          this.invalidateSubject.invalidate();
        },
        error => {
          this.fuseSplashScreenService.hide();
        });
    }
  }

  valueChanged($event) {
    console.log('Inside Handler', $event);
    if (this.handleAction($event)) {
      return;
    }
    if (this.handleCommand($event)) {
      return;
    }
    if ($event.item && $event.fieldDefinition && $event.fieldSection) {
      switch ($event.fieldSection.id) {
        case 'translation':
          return;
        case 'activityfilter':
          this.executeActivityFilterActions($event);
          return;
      }
    }
  }

  private executeActivityFilterActions($event) {
    switch ($event.fieldDefinition.key) {
      case 'ShareType':
        const updatePlatformReportFieldCommand = new PlatformCommand('UpdateActivityFilterCommand', 'CollaborationApi');
        updatePlatformReportFieldCommand.fieldValues['FilterId'] = $event.item.id;
        updatePlatformReportFieldCommand.fieldValues['FieldKey'] = $event.fieldDefinition.key;
        updatePlatformReportFieldCommand.fieldValues['FieldValue'] = $event.action.id;
        this.executeCommandToApi(updatePlatformReportFieldCommand,'ShareType');
        break;
      case 'Title':
        this.router.navigateByUrl(`activities/filter/${$event.item.id}`);
        break;
    }
  }

  private handleCommand($event): boolean {
    if ($event.command) {
      switch ($event.command.name) {
        case 'CreateFilterCommand':
          this.crateFilter($event.command);
          return true;
        default:
          this.executeCommand($event.command);
          return true;
      }
    }
    return false;
  }

  private handleAction($event): boolean {
    if (this.selectedTabModel && $event.action) {
      switch ($event.action.id) {
        case 'Open':
          this.router.navigateByUrl(`activities/filter/${$event.item.id}`);
          return true;
        case 'Delete':
          this.deleteActivityFilter($event, $event.action.id);
          return true;
        case 'Share':
          this.shareActivityFilter($event);
          return true;
        case 'Archive':
          this.toggleArchiveActivityFilter($event, true, $event.action.id);
          return true;
        case 'Unarchive':
          this.toggleArchiveActivityFilter($event, false,$event.action.id);
          return true;
        case 'AttachTask':
          this.attachToTask($event);
          return true;
        case 'TaskClosed':
          this.updateTaskStatus($event);
          return true;
        case 'Edit':
          this.openCellEditorDialog($event);
          return true;
        case 'Edit-Filter':
          this.openEditor($event);
          return true;
      }
    }
    return false;
  }

  private openCellEditorDialog(event) {
    const minWidth = '800px';
    const maxWidth = '800px';

    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, event.fieldSection.id)
      .subscribe(state => {
        if (state.action === 'OK') {
          const value = event.item.cells[event.fieldDefinition.key].value;
          const command = new PlatformCommand('UpdateActivityFilterCommand', 'CollaborationApi');
          command.fieldValues['FilterId'] = event.item.id;
          command.fieldValues['Description'] = value;
          command.fieldValues['FieldKey'] = event.fieldDefinition.key;
          this.executeCommandToApi(command);
        }
      });
  }

  private toggleArchiveActivityFilter($event: any, isArchived: boolean, action: string) {
    const command = new PlatformCommand('ToggleArchiveActivityFilterCommand', 'CollaborationApi');
    command.fieldValues['FilterId'] = $event.item.id;
    command.fieldValues['IsArchived'] = isArchived;
    this.executeCommandToApi(command,action);
  }

  private deleteActivityFilter($event: any, action: any) {
    this.dialogService.showYesNoDialog('Delete Activity Filter', 'Are you sure you want to delete this activity filter?').pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
      if (result && result.action === 'OK') {
        const command = new PlatformCommand('DeleteActivityFilterCommand', 'CollaborationApi');
        command.fieldValues['FilterId'] = $event.item.id;
        this.executeCommandToApi(command,action);
      }
    });
  }

  private attachToTask($event: any) {
    const command = new PlatformCommand('AttachTaskToActivityFilterCommand', 'CollaborationApi');
    command.fieldValues['FilterId'] = $event.item.id;
    command.fieldValues['TicketId'] = $event.payload.id;
    command.fieldValues['Scope'] = $event.payload.scopeInt;
    this.executeCommandToApi(command);
  }

  private shareActivityFilter($event: any) {
    if ($event.item.cells.Task && $event.item.cells.Task.displayText) {
      const task = $event.item.cells.Task.value;
      if (task && task.ticketId && task.boardScope) {
        const taskMenuDetails = new TaskMenuDetails();
        taskMenuDetails.id = 'TaskAssignee';
        this.taskManagerService.openTaskByTaskId(task.ticketId,
          GraphqlContentScope.getScope(GraphqlContentScope.getScope(task.boardScope)), null, null,
          taskMenuDetails, true)
          .pipe(take(1)).subscribe(() => {
          this.invalidateSubject.invalidate();
        });
      }
    }
  }

  private updateTaskStatus($event: any) {
    const activityFilterId = $event.item.id;
    this.invalidateSubject.invalidate();
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }

  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private openEditor($event: any) {
    this.router.navigateByUrl(`activities/filter/${$event.item.id}?isEdit=true`);
  }

  private crateFilter(command: PlatformCommand) {
    console.log('crate filter:', command);
    this.executeCommandToApi(command);
  }

  private invalidatePlatformLink(action: string, platformLinkModel: MagicLinkModel) {
    if(platformLinkModel) {
      switch (action) {
        case 'Delete':
        case 'Archive':
        case 'ShareType':
          this.magicLinkModelValueChangedHandler({id: 'PlatformToolInformationBarComponent', value: platformLinkModel.informationBar});
              break;
      }
    }
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }
}
